import { render } from "./CodeMirror.vue?vue&type=template&id=5a8615ee&ts=true"
import script from "./CodeMirror.vue?vue&type=script&lang=ts"
export * from "./CodeMirror.vue?vue&type=script&lang=ts"

import "./CodeMirror.vue?vue&type=style&index=0&id=5a8615ee&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__